import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CartService } from '../../../cart/services/cart.service';
import { CollectionsService } from '../../../collections/service/collections.service';
import { ProductInterface } from '../../interfaces/product.interface';
import i18next from 'i18next';
import { DataService } from '../../../../core/services/data.service';
import { getCurrencySymbol } from '@angular/common';
import { Lightbox } from 'ngx-lightbox';
import { ImagePipe } from 'src/core/pipes/image.pipe';
import { I18NextPipe } from 'angular-i18next';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent implements OnInit {
  collectionId: string;
  productId: string;
  materials!: string[];
  colors!: string[];
  productData!: ProductInterface;
  crossSelling: any;
  priceActive = false;
  freestanding = false;
  lang!: string;
  currencySymbol!: string;
  priceListTxt!: string;
  private dataLoaded = this.collectionsService.dataLoaded;
  private subscription: Subscription = new Subscription();

  constructor(
    private activatedRoute: ActivatedRoute,
    public collectionsService: CollectionsService,
    private cartService: CartService,
    private dataService: DataService,
    private lightbox: Lightbox,
    private imagePipe: ImagePipe,
    private i18nPipe: I18NextPipe
  ) {
    this.collectionId = this.activatedRoute.snapshot.params.id;
    this.productId = this.activatedRoute.snapshot.params.productId;
    const collectionDataSub =
      this.collectionsService.loadDataObservable$.subscribe(() => {
        this.serveData();
      });
    this.subscription.add(collectionDataSub);
  }

  ngOnInit(): void {
    if (this.dataLoaded) {
      this.serveData();
    }
    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscription.add(priceActiveSub);
  }

  serveData(): void {
    this.currencySymbol = getCurrencySymbol(
      this.collectionsService.currencyCode,
      'narrow'
    );
    this.priceListTxt = this.dataService.dataPriceLists.texts.priceInfo;

    this.lang = i18next.language;
    this.materials =
      this.dataService.filterList.articleFilters.material[this.lang];
    this.colors = this.dataService.filterList.articleFilters.color[this.lang];
    this.productData = this.collectionsService.getProductData(
      Number(this.productId)
    );
    console.log(this.productData);
    this.crossSelling = this.collectionsService.getCrossSellingProducts(
      Number(this.productId)
    );
    // console.log(this.crossSelling);
    if (this.isFreestanding(this.productData.images.freestanding_1)) {
      this.freestanding = true;
    }
  }

  originalOrder = (a: { key: number }, b: { key: number }) => {
    return 0;
  };

  isFreestanding(url: string): boolean {
    return /\.(png)$/.test(url);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  openLightbox() {
    this.lightbox.open(
      [
        {
          src: this.imagePipe.transform(this.productData.images.freestanding_1),
          caption: this.i18nPipe.transform(this.productData.texts.title),
          thumb: this.imagePipe.transform(
            this.productData.images.freestanding_1
          ),
        },
      ],
      0
    );
  }

  openLightboxForExperience(e: Event, url: string) {
    e.preventDefault();
    e.stopPropagation();
    this.lightbox.open(
      [
        {
          src: this.imagePipe.transform(url),
          caption: '',
          thumb: this.imagePipe.transform(url),
        },
      ],
      0
    );
  }
}
